<template>
    <div v-if="isVisible" class="modal-overlay">
        <DDialog :modelValue="isVisible" @update:modelValue="updateVisibility">
            <DCard>
                <DCardSection>
                    <div class="title">
                        <h5>Data Types</h5>
                    </div>
                </DCardSection>

                <DCardSection class="scrollable-section">
                    <div v-for="data in qDialogContent" :key="data.id" class="margin-bottom-16">
                        <DCard bordered>
                            <DCardSection class="content">
                                <div><strong>Identifier:</strong> {{ data.identifier }}</div>
                                <div><strong>Group:</strong> {{ data.group }}</div>
                                <div><strong>Period:</strong> {{ data.period }}</div>
                                <div><strong>Example:</strong> {{ data.example }}</div>
                                <input type="checkbox" :checked="data.checked" @change="data.checked = !data.checked" />
                                <!--DCheckbox v-model="data.checked" :val="data.id"/-->
                            </DCardSection>
                        </DCard>
                    </div>
                </DCardSection>
                <DCardSection>
                    <div class="checkbox-container content">
                        <DCheckbox label="Sort by Identifier" v-model="sortBy.identifier" />
                        <DCheckbox label="Sort by Group" v-model="sortBy.group" />
                        <DCheckbox label="Sort by Period" v-model="sortBy.period" />
                    </div>
                    <div style="text-align: right;">
                        <DButton label="Cancel" color="primary" @click="onCancelClick" />
                        <DButton label="Select types" color="positive" @click="onConfirmSelection" />
                    </div>
                </DCardSection>
                <DSpinner :visible="visible" size="60px" color="primary" />
            </DCard>
        </DDialog>
    </div>
</template>

<script>
import { loadBubbleTypes } from "../state/dashboard-state"
import DButton from '@components/ui/DButton.vue'
import DCard from '@components/ui/DCard.vue'
import DCardSection from '@components/ui/DCardSection.vue'
import DCheckbox from '@components/ui/DCheckbox.vue'
import DDialog from '@components/ui/DDialog.vue'
import DSpinner from '@components/ui/DSpinner.vue'
export default {
    inject: ['dashboardState'],
    components: {
        DButton,
        DCard,
        DCardSection,
        DCheckbox,
        DDialog,
        DSpinner
    },
    data() {
        return {
            visible: true,
            qDialogContent: [],
            selectedValues: [],
            sortBy: {
                identifier: false,
                group: false,
                period: false
            }
        }
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        'sortBy.identifier'() {
            this.applySorting()
        },
        'sortBy.group'() {
            this.applySorting()
        },
        'sortBy.period'() {
            this.applySorting()
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.showBubbleForm()
        })
    },
    methods: {
        applySorting() {
            this.qDialogContent.sort((a, b) => {
                return this.sortBy.identifier ? a.identifier.localeCompare(b.identifier) : 0 ||
                    this.sortBy.group ? a.group.localeCompare(b.group) : 0 ||
                        this.sortBy.period ? a.period.localeCompare(b.period) : 0
            })
        },
        async showBubbleForm() {
            await loadBubbleTypes().then(() => {
                this.visible = false
            })
            this.qDialogContent = this.dashboardState.dataTypeList.map(dataType => {
                // Check if the dataType id is present in the dashboard data
                const isChecked = this.dashboardState.dashboard.data.some(dashboardData => dashboardData.dataTypeId === dataType.id)
                return {
                    ...dataType,
                    checked: isChecked
                }
            })
        },
        onConfirmSelection() {
            this.selectedValues = this.qDialogContent
                .filter(data => data.checked)
                .filter(qdContent => !this.dashboardState.dashboard.data.some(dashboardItem => dashboardItem.dataTypeId === qdContent.id))
                .map(data => data.id)

            if (this.selectedValues.length === 0) {
                this.$emit('show-notification', 'negative', 'Please select a type')
            } else {
                this.$emit('confirm', { selectedValues: this.selectedValues })
                this.hide()
            }

        },
        onCancelClick() {
            this.hide()
        },
        hide() {
            this.$emit('cancel')
        },

        onOKClick() {
            if (this.selectedValues.length === 0) {
                this.$emit('show-notification', 'negative', 'Please select a type')
            } else {
                this.$emit('confirm', { imagePreview: this.imagePreview, level: this.level, name: this.name })
                this.hide()
            }
        },
        updateVisibility(value) {
            this.$emit('update:isVisible', value)
        }
    },
};
</script>
<style scoped lang="scss">
.scrollable-section {
    max-height: 600px;
    /* Adjust this value as needed */
    overflow-y: auto;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.title {
    font-size: 20px;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em;
    color: black;
}

h5 {
    margin: 0px;
    text-align: left;
}

.checkbox-container {
    display: flex;
    justify-content: center;
    gap: 10px;
    /* Optional: Adds some space between the checkboxes */
}
.align-left {
    display: block;
  margin-left: 0;
  margin-right: auto;
}
.content {
    font-weight: 500;
    font-size: 14px;
    color: black;
    text-align: left;
}
.margin-bottom-16{
    margin-bottom: 16px;
}
</style>
